import { pgEnum as drizzlePgEnum } from "drizzle-orm/pg-core";

/** Symbol to store the original key→value mapping on pgEnum results */
export const ENUM_MAP = Symbol.for("drizzle:EnumMap");

export function toPgEnum<const T extends Record<string, string>>(record: T) {
  return Object.values(record) as [T[keyof T], ...T[keyof T][]];
}

export function pgOrmEnum<const TName extends string, const TEnum extends Record<string, string>>(
  name: TName,
  values: TEnum,
) {
  const pgValues = Object.values(values) as [TEnum[keyof TEnum], ...TEnum[keyof TEnum][]];
  const result = drizzlePgEnum(name, pgValues);
  (result as any)[ENUM_MAP] = values;
  return result;
}
